import React from 'react';
import { useFormContext, UseFormSetValue } from 'react-hook-form';

import { hookFormFieldHoc, HookFormFieldCoreProps } from '../field.hoc';

export interface RadioProps extends HookFormFieldCoreProps {
  displayText?: string;
  value?: string | number;
  changeTrigger?: ({ setValue }: { setValue: UseFormSetValue<any> }) => void;
  nlogAreaCode?: string;
}

const Radio: React.FC<RadioProps> = ({
  field,
  className,
  displayText,
  value,
  disabled = false,
  changeTrigger,
  onChange,
  nlogAreaCode,
}) => {
  const { setValue } = useFormContext();

  const handleChange = changeTrigger
    ? (event: React.ChangeEvent<HTMLInputElement>) => {
        field?.onChange?.(event);
        changeTrigger({ setValue });
      }
    : field?.onChange;

  return (
    <label className={className} htmlFor={value?.toString()}>
      <input
        {...field}
        disabled={disabled}
        type="radio"
        value={value}
        id={value?.toString()}
        checked={field?.value === value}
        onChange={handleChange}
        {...(nlogAreaCode ? { 'data-event-nlog': 'click', 'data-event-area-code': nlogAreaCode } : {})}
      />
      {displayText && <span>{displayText}</span>}
    </label>
  );
};

export default hookFormFieldHoc(Radio);
